import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';

// Layout Components
import GlobalLayout from '../layouts/GlobalLayout';
import PageView from '../layouts/PageView';

// Page Components
import Login from '../pages/login/Login';
import Dashboard from '../pages/dashboard/Dashboard';

// Analysis Pages
import UserAnalysis from '../pages/analytics/UserAnalysis';
import WatchedMovieAnalysis from '../pages/analytics/WatchedMovieAnalysis';
import SubscriptionAnalysis from '../pages/analytics/SubscriptionAnalysis';

// User Pages
import UserList from '../pages/users/UserList';
import UsersByDateRange from '../pages/users/UsersByDateRange';
import EditUser from '../pages/users/EditUser';
import UserDetails from '../pages/users/UserDetails';
import AddAdmin from '../pages/users/AddAdmin';

// Banner Pages
import BannerList from '../pages/banners/BannerList';
import AddBanner from '../pages/banners/AddBanner';
import EditBanner from '../pages/banners/EditBanner';

// OnBoarding Pages
import OnBoardingList from '../pages/onboarding/OnBoardingList';
import OnBoardingForm from '../pages/onboarding/OnBoardingForm';

// Category Pages
import CategoryList from '../pages/categories/CategoryList';
import AddCategory from '../pages/categories/AddCategory';
import EditCategory from '../pages/categories/EditCategory';

// Promo Pages
import PromoList from '../pages/promo/PromoList';
import PromoForm from '../pages/promo/PromoForm';
import PromoCampaignList from '../pages/promo_campaign/PromoCampaignList';
import PromoCampaignForm from '../pages/promo_campaign/PromoCampaignForm';
import RzpOfferList from '../pages/promo_rzp_offer/RzpOfferList';
import RzpOfferForm from '../pages/promo_rzp_offer/RzpOfferForm';

// Master Pages
import CountryList from '../pages/master/Country/CountryList';
import AddCountry from '../pages/master/Country/AddCountry';
import EditCountry from '../pages/master/Country/EditCountry';
import CurrencyList from '../pages/master/Currency/CurrencyList';
import AddCurrency from '../pages/master/Currency/AddCurrency';
import EditCurrency from '../pages/master/Currency/EditCurrency';
import GenreList from '../pages/master/VideoGenre/GenreList';
import AddGenre from '../pages/master/VideoGenre/AddGenre';
import EditGenre from '../pages/master/VideoGenre/EditGenre';
import LanguageList from '../pages/master/VideoLanguages/LanguageList';
import AddLanguage from '../pages/master/VideoLanguages/AddLanguage';
import EditLanguage from '../pages/master/VideoLanguages/EditLanguage';
import TagList from '../pages/master/Tag/TagList';
import AddTag from '../pages/master/Tag/AddTag';
import EditTag from '../pages/master/Tag/EditTag';
import ContentTypeList from '../pages/master/ContentType/ContentTypeList';
import AddContentType from '../pages/master/ContentType/AddContentType';
import EditContentType from '../pages/master/ContentType/EditContentType';
import SalesChannelList from '../pages/master/SalesChannel/SalesChannelList';
import AddSalesChannel from '../pages/master/SalesChannel/AddSalesChannel';
import EditSalesChannel from '../pages/master/SalesChannel/EditSalesChannel';
import FaqList from '../pages/master/FAQs/FaqList';
import AddFaq from '../pages/master/FAQs/AddFaq';
import EditFaq from '../pages/master/FAQs/EditFaq';
import PrivacyPolicyList from '../pages/master/PrivacyPolicy/PrivacyPolicyList';
import AddPrivacyPolicy from '../pages/master/PrivacyPolicy/AddPrivacyPolicy';
import EditPrivacyPolicy from '../pages/master/PrivacyPolicy/EditPrivacyPolicy';
import TermsConditionsList from '../pages/master/TermsConditions/TermsConditionsList';
import AddTermsConditions from '../pages/master/TermsConditions/AddTermsConditions';
import EditTermsConditions from '../pages/master/TermsConditions/EditTermsConditions';
import AboutUs from '../pages/master/AboutUs/AboutUs';
import MobileAppStoreList from '../pages/master/MobileAppStore/MobileAppStoreList';
import AddMobileAppStore from '../pages/master/MobileAppStore/AddMobileAppStore';
import EditMobileAppStore from '../pages/master/MobileAppStore/EditMobileAppStore';
import ContentComplaintsList from '../pages/master/ContentComplaints/ContentComplaintsList';
import AddContentComplaints from '../pages/master/ContentComplaints/AddContentComplaints';
import EditContentComplaints from '../pages/master/ContentComplaints/EditContentComplaints';

// Video Pages
import QualityList from '../pages/video/Quality/QualityList';
import EditQuality from '../pages/video/Quality/EditQuality';
import AddQuality from '../pages/video/Quality/AddQuality';
import RatingList from '../pages/video/Ratings/RatingList';
import EditRating from '../pages/video/Ratings/EditRating';
import AddRating from '../pages/video/Ratings/AddRating';

// Subscription Pages
import PlanList from '../pages/subscription/SubscriptionPlan/PlanList';
import EditPlan from '../pages/subscription/SubscriptionPlan/EditPlan';
import AddPlan from '../pages/subscription/SubscriptionPlan/AddPlan';

// Movie Pages
import ShowList from '../pages/video/Show/ShowList';
import EditShow from '../pages/video/Show/EditShow';
import AddShow from '../pages/video/Show/AddShow';

// TV Show Pages
import TvShowList from '../pages/Tv_show/Show/ShowList';
import EditTvShow from '../pages/Tv_show/Show/EditShow';
import AddTvShow from '../pages/Tv_show/Show/AddShow';
import EpisodeList from '../pages/Tv_show/Episode/ShowList';
import EditEpisode from '../pages/Tv_show/Episode/EditShow';
import AddEpisode from '../pages/Tv_show/Episode/AddShow';

// Payment Pages
import PaymentModeList from '../pages/master/PaymentModes/PaymentModeList';
import AddPaymentMode from '../pages/master/PaymentModes/AddPaymentMode';
import EditPaymentMode from '../pages/master/PaymentModes/EditPaymentMode';
import PaymentKeyList from '../pages/payment/PaymentKey/PaymentKeyList';
import EditPaymentKey from '../pages/payment/PaymentKey/EditPaymentKey';
import AddPaymentKey from '../pages/payment/PaymentKey/AddPaymentKey';

// Media Data Pages
import MEC from '../pages/media_data/MEC';
import MMC from '../pages/media_data/MMC';
import MECForm from '../pages/media_data/MECForm';
import MMCForm from '../pages/media_data/MMCForm';

// Other Pages
import ExcelData from '../pages/excelData/ExcelData';
import RegisterUsers from '../pages/reports/RegisterUsers';
import Transactions from '../pages/Transactions/Transactions';

// Settings Pages
import GlobalSettingsList from '../pages/settings/Global_settings/GlobalSettingsList';
import EditGlobalSettings from '../pages/settings/Global_settings/EditGlobalSettings';
import AddGlobalSettings from '../pages/settings/Global_settings/AddGlobalSettings';
import GlobalSettings from '../pages/settings/Global_settings/GlobalSettings';
import PrivateSettingsList from '../pages/settings/Private_Settings/PrivateSettingsList';
import EditPrivateSettings from '../pages/settings/Private_Settings/EditPrivateSettings';
import AddPrivateSettings from '../pages/settings/Private_Settings/AddPrivateSettings';

// New Dashboard
import NewDashboard from '../pages/NewDashboard/NewDashboard';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Login Route */}
        <Route path="/login" element={<Login />} />
        
        {/* Main Admin Routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <GlobalLayout />
          </ProtectedRoute>
        }>
          {/* Dashboard */}
          <Route path="/dashboard/dashboard" element={<Dashboard />} />
          
          {/* Analysis Routes */}
          <Route path="/analysis" element={<PageView />}>
            <Route index element={<Navigate to="/analysis/userAnalysis" replace />} />
            <Route path="userAnalysis" element={<UserAnalysis />} />
            <Route path="watchedMovieAnalysis" element={<WatchedMovieAnalysis />} />
            <Route path="subscriptionsAnalysis" element={<SubscriptionAnalysis />} />
          </Route>
          
          {/* User Routes */}
          <Route path="/users" element={<PageView />}>
            <Route index element={<Navigate to="/users/user" replace />} />
            <Route path="usersByDateRange" element={<UsersByDateRange />} />
            <Route path="user" element={<UserList />} />
            <Route path="edit/:user_id" element={<EditUser />} />
            <Route path="details/:user_id" element={<UserDetails />} />
            <Route path="addadmin" element={<AddAdmin />} />
          </Route>
          
          {/* Banner Routes */}
          <Route path="/banners" element={<PageView />}>
            <Route index element={<Navigate to="/banners/banner" replace />} />
            <Route path="banner" element={<BannerList />} />
            <Route path="addbanner" element={<AddBanner />} />
            <Route path="editbanner/:banner_id" element={<EditBanner />} />
          </Route>
          
          {/* OnBoarding Routes */}
          <Route path="/onboarding" element={<PageView />}>
            <Route index element={<Navigate to="/onboarding/onboarding-list" replace />} />
            <Route path="onboarding-list" element={<OnBoardingList />} />
            <Route path="onboarding-form/:mob_id" element={<OnBoardingForm />} />
          </Route>
          
          {/* Category Routes */}
          <Route path="/categories" element={<PageView />}>
            <Route index element={<Navigate to="/categories/category" replace />} />
            <Route path="category" element={<CategoryList />} />
            <Route path="addcategory" element={<AddCategory />} />
            <Route path="editcategory/:category_id" element={<EditCategory />} />
          </Route>
          
          {/* Promo Routes */}
          <Route path="/promo" element={<PageView />}>
            <Route path="promo-list" element={<PromoList />} />
            <Route path="promo-form/:promo_id" element={<PromoForm />} />
            <Route path="promo-campaign-list" element={<PromoCampaignList />} />
            <Route path="promo-campaign-form/:pc_id" element={<PromoCampaignForm />} />
            <Route path="promo-rzp-offer-list" element={<RzpOfferList />} />
            <Route path="promo-rzp-offer-form/:rzp_offer_id" element={<RzpOfferForm />} />
          </Route>
          
          {/* Master Routes */}
          <Route path="/master" element={<PageView />}>
            {/* Country */}
            <Route path="country" element={<CountryList />} />
            <Route path="addcountry" element={<AddCountry />} />
            <Route path="editCountry/:country_id" element={<EditCountry />} />
            
            {/* Currency */}
            <Route path="currency" element={<CurrencyList />} />
            <Route path="addcurrency" element={<AddCurrency />} />
            <Route path="editCurrency/:curr_id" element={<EditCurrency />} />
            
            {/* Genre */}
            <Route path="videogenre" element={<GenreList />} />
            <Route path="addvideogenre" element={<AddGenre />} />
            <Route path="editvideogenre/:genre_id" element={<EditGenre />} />
            
            {/* Language */}
            <Route path="videolanguage" element={<LanguageList />} />
            <Route path="addvideolanguage" element={<AddLanguage />} />
            <Route path="editvideolanguage/:lang_id" element={<EditLanguage />} />
            
            {/* Tag */}
            <Route path="tag" element={<TagList />} />
            <Route path="addTag" element={<AddTag />} />
            <Route path="editTag/:tag_id" element={<EditTag />} />
            
            {/* Content Type */}
            <Route path="contenttype" element={<ContentTypeList />} />
            <Route path="addcontenttype" element={<AddContentType />} />
            <Route path="editcontenttype/:ct_id" element={<EditContentType />} />
            
            {/* Sales Channel */}
            <Route path="sales_channel" element={<SalesChannelList />} />
            <Route path="add_sales_channel" element={<AddSalesChannel />} />
            <Route path="sales_channel/:sc_id" element={<EditSalesChannel />} />
            
            {/* FAQs */}
            <Route path="faq" element={<FaqList />} />
            <Route path="add_faq" element={<AddFaq />} />
            <Route path="edit_faq/:faq_id" element={<EditFaq />} />
            
            {/* Privacy Policy */}
            <Route path="privacy_policy" element={<PrivacyPolicyList />} />
            <Route path="add_privacy_policy" element={<AddPrivacyPolicy />} />
            <Route path="edit_privacy_policy/:pp_id" element={<EditPrivacyPolicy />} />
            
            {/* Terms Conditions */}
            <Route path="terms_conditions" element={<TermsConditionsList />} />
            <Route path="add_terms_conditions" element={<AddTermsConditions />} />
            <Route path="edit_terms_conditions/:tc_id" element={<EditTermsConditions />} />
            
            {/* About Us */}
            <Route path="about_us" element={<AboutUs />} />
            
            {/* Mobile App Store */}
            <Route path="mobileappstore" element={<MobileAppStoreList />} />
            <Route path="addmobileappstore" element={<AddMobileAppStore />} />
            <Route path="editmobileappstore/:store_id" element={<EditMobileAppStore />} />
            
            {/* Content Complaints */}
            <Route path="contentComplaints" element={<ContentComplaintsList />} />
            <Route path="addContentComplaints" element={<AddContentComplaints />} />
            <Route path="editContentComplaints/:content_id" element={<EditContentComplaints />} />
          </Route>
          
          {/* Video Routes */}
          <Route path="/Video" element={<PageView />}>
            <Route index element={<Navigate to="/Video/Quality" replace />} />
            <Route path="Quality" element={<QualityList />} />
            <Route path="Quality/edit/:vq_id" element={<EditQuality />} />
            <Route path="Quality/addQuality" element={<AddQuality />} />
            <Route path="ratings" element={<RatingList />} />
            <Route path="ratings/edit/:vr_id" element={<EditRating />} />
            <Route path="ratings/addRatings" element={<AddRating />} />
          </Route>
          
          {/* Subscription Routes */}
          <Route path="/subscriptions" element={<PageView />}>
            <Route index element={<Navigate to="/subscriptions/plan" replace />} />
            <Route path="plan" element={<PlanList />} />
            <Route path="plan/edit/:plan_id" element={<EditPlan />} />
            <Route path="plan/addPlan" element={<AddPlan />} />
          </Route>
          
          {/* Movie Routes - Special case with absolute paths */}
          <Route path="/Video/Show" element={<ShowList />} />
          <Route path="/Video/Show/edit/:video_show_id" element={<EditShow />} />
          <Route path="/Video/Show/addVideoShow" element={<AddShow />} />
          
          {/* TV Show Routes */}
          <Route path="/TvShows" element={<PageView />}>
            <Route index element={<Navigate to="/TvShows/Shows" replace />} />
            <Route path="Shows" element={<TvShowList />} />
            <Route path="Shows/edit/:tv_show_id" element={<EditTvShow />} />
            <Route path="Shows/addTvShow" element={<AddTvShow />} />
            <Route path="episodes" element={<EpisodeList />} />
            <Route path="episodes/edit/:episode_id" element={<EditEpisode />} />
            <Route path="episodes/addTvShow" element={<AddEpisode />} />
          </Route>
          
          {/* Payment Routes */}
          <Route path="/payment" element={<PageView />}>
            <Route index element={<Navigate to="/payment/key" replace />} />
            <Route path="key" element={<PaymentKeyList />} />
            <Route path="key/edit/:payment_keys_id" element={<EditPaymentKey />} />
            <Route path="key/addKey" element={<AddPaymentKey />} />
          </Route>
          
          {/* Payment Mode Routes - Special case with absolute paths */}
          <Route path="/master/paymentmodes" element={<PaymentModeList />} />
          <Route path="/master/addpaymentmode" element={<AddPaymentMode />} />
          <Route path="/master/editPaymentMode/:pm_id" element={<EditPaymentMode />} />
          
          {/* Media Data Routes */}
          <Route path="/media-data" element={<PageView />}>
            <Route index element={<Navigate to="/media-data/mec" replace />} />
            <Route path="mec" element={<MEC />} />
            <Route path="mmc" element={<MMC />} />
            <Route path="mec-form/:id" element={<MECForm />} />
            <Route path="mmc-form/:id" element={<MMCForm />} />
          </Route>
          
          {/* Other Routes */}
          <Route path="/excelData" element={<ExcelData />} />
          <Route path="/registerUsers" element={<RegisterUsers />} />
          <Route path="/transactions" element={<Transactions />} />
          
          {/* Settings Routes */}
          <Route path="/settings" element={<PageView />}>
            <Route index element={<Navigate to="/settings/global_settings" replace />} />
            <Route path="global_settings" element={<GlobalSettingsList />} />
            <Route path="global_settings/:gls_id" element={<EditGlobalSettings />} />
            <Route path="add_global_settings" element={<AddGlobalSettings />} />
            <Route path="update_global_settings" element={<GlobalSettings />} />
            <Route path="private_settings" element={<PrivateSettingsList />} />
            <Route path="private_settings/:private_gls_id" element={<EditPrivateSettings />} />
            <Route path="add_private_settings" element={<AddPrivateSettings />} />
          </Route>
          
          {/* Default redirect */}
          <Route index element={<Navigate to="/login" replace />} />
        </Route>
        
        {/* Videoshow redirect route */}
        <Route path="/Videoshow" element={<Navigate to="/Video/Show" replace />} />
        
        {/* New Dashboard Route */}
        <Route path="/new-dashboard" element={<NewDashboard />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
